import { render } from "./PageViewPSBditolakPengembalian.vue?vue&type=template&id=500bded8"
import script from "./PageViewPSBditolakPengembalian.vue?vue&type=script&lang=js"
export * from "./PageViewPSBditolakPengembalian.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__